module.exports = require('./dom')(document)
